import { FontAwesomeSvgIcon } from 'react-fontawesome-svg-icon'

import { faGaugeCircleBolt } from '@fortawesome/pro-light-svg-icons'

import { Card } from '@infura/packages.ui/Card'
import { Text } from '@infura/packages.ui/Text'
import { Tooltip } from '@infura/packages.ui/Tooltip'

import { CreditThroughputValues } from 'components/dashboard/analytics-overview/CreditThroughput/CreditThroughputValues'

export const CreditThroughput = () => {
  return (
    <Card>
      <div className='flex h-[172px] flex-col justify-between sm:h-full'>
        <div className='flex items-center gap-2'>
          <FontAwesomeSvgIcon className='text-text-default' icon={faGaugeCircleBolt} size='sm' />
          <Text className='font-bold'>Credit Throughput</Text>
          <Tooltip
            className='z-1'
            content={
              <div>
                The number of estimated credits that are used per second. Throughput under the limit ensures consistent
                performance. Going beyond the limit will result in rate limited requests.
              </div>
            }
          />
        </div>
        <CreditThroughputValues />
      </div>
    </Card>
  )
}
